import { render, staticRenderFns } from "./account-edit.vue?vue&type=template&id=fec966ee&scoped=true&"
import script from "./account-edit.vue?vue&type=script&lang=js&"
export * from "./account-edit.vue?vue&type=script&lang=js&"
import style0 from "./account-edit.sass?vue&type=style&index=0&id=fec966ee&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fec966ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/project/goeatBackup/goeat-backup-goeat-web/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VBreadcrumbs,VBtn,VCard,VCardActions,VCardTitle,VContainer,VDialog,VFlex,VForm,VIcon,VLayout,VSpacer,VTextField})
